import { FaReact, FaNode } from "react-icons/fa";
import { SiRedux, SiMongodb, SiFirebase, SiTypescript, SiGraphql } from "react-icons/si";
import { ReactComponent as Express } from "../../assets/svg/express.svg";

export const technologies = [
    {
        name: "React",
        Logo: FaReact,
        color: "#00D8FF",
    },
    {
        name: "Redux",
        Logo: SiRedux,
        color: "#764ABC",
    },
    {
        name: "NodeJS",
        Logo: FaNode,
        color: "#83CD29",
    },
    {
        name: "Express",
        Logo: Express,
        color: "#303030",
    },
    {
        name: "GraphQL",
        Logo: SiGraphql,
        color: "#DF33A7",
    },
    {
        name: "Typescript",
        Logo: SiTypescript,
        color: "#2F74C0",
    },
    {
        name: "MongoDB",
        Logo: SiMongodb,
        color: "#4EB13E",
    },
    {
        name: "Firebase",
        Logo: SiFirebase,
        color: "#F4C43D",
    },
];
